const featureItems = [
  {
    icon: 'ri-flashlight-line',
    title: '秒播不卡',
    desc: '独家加速技术确保高清电影免费在线观看流畅不缓冲，告别转圈等待',
  },
  {
    icon: 'ri-hd-line',
    title: '高清画质',
    desc: '全站影视资源均支持高清模式，色彩饱满细节清晰，观影体验媲美付费平台',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日更新',
    desc: '实时同步最新电影与热门剧集，片源库每日新增，永远不会剧荒',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全纯净',
    desc: '无弹窗广告干扰，无需注册登录，纯净观影环境保护您的隐私安全',
  },
  {
    icon: 'ri-device-line',
    title: '全端适配',
    desc: '完美兼容手机、平板、电脑等所有设备，随时随地畅享免费影院',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100/50">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-3">
          平台优势
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14">
          为什么数百万用户选择夜猫电影院看高清电影
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {featureItems.map((item, idx) => (
            <div
              key={idx}
              className="group bg-background-50 border border-background-200/60 rounded-xl p-6 text-center transition-all duration-200 hover:-translate-y-1 cursor-pointer"
            >
              <div className="w-14 h-14 mx-auto mb-4 rounded-2xl bg-primary-100 flex items-center justify-center transition-colors duration-200 group-hover:bg-primary-200/70">
                <i className={`${item.icon} text-primary-600 text-2xl`}></i>
              </div>
              <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}